import * as React from 'react';

function SvgHamburgerButton(props) {
	return (
		<svg width="1em" height="1em" viewBox="0 0 30 19" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g fill="#000" fillRule="evenodd">
				<path d="M0 0h30v3H0zM0 8h30v3H0zM0 16h30v3H0z" />
			</g>
		</svg>
	);
}

export default SvgHamburgerButton;
